import { Box, Fade } from "@mui/material";
import { LoginBox } from "../../../components/AtomicDesign/Organisms";
import useAuth from "../../../hooks/context/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useBreakpoints } from "../../../hooks/useBreakpoins";

export function Login() {
  const { isSmalldesktop } = useBreakpoints();
  const { user, token } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (user && token) {
      nav("/home");
    }
    // eslint-disable-next-line
  }, [user, token]);

  return (
    <Fade
      in={true}
      style={{
        transformOrigin: "0 0 0",
      }}
      timeout={1000}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          mt: isSmalldesktop ? 5 : 15,
          mb: isSmalldesktop ? 5 : 15,
        }}
      >
        <LoginBox />
      </Box>
    </Fade>
  );
}
